module.exports = __webpack_public_path__ + "img/tjfoot10.7cc48370.jpg";